import { companiesCompanyIdEmailSelfServeConfigurationData } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdEmailSelfServeSendingDomainDomainIdCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdEmailSelfServeConfigurationData,
];
